import { useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./LanguageDropDown.module.css";
import classNames from "classnames";
import useDetectClose from "../hooks/useDetectClose";
import language_icon from "../image/global_icon.png";

function LanguageDropDown() {
  const dropDownRef = useRef(null);
  const [isOpen, setIsOpen] = useDetectClose(dropDownRef, false);
  return (
    <div className={styles.dropDownMenu}>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className={styles.button}
      >
        <img
          src={language_icon}
          id="language_icon"
          className={styles.web}
          ref={dropDownRef}
          alt="change language"
          height="20"
          width="20"
        />
      </button>

      <div
        className={classNames([styles.menu, { [styles.active]: isOpen }])}
        aria-labelledby="language_icon"
      >
        <Link to="/kr" className={styles.dropdown_item}>
          한국어
        </Link>
        <Link to="/en" className={styles.dropdown_item}>
          English
        </Link>
        {/* 메뉴 리스트들 */}
      </div>
    </div>
  );
}

export default LanguageDropDown;
